import SearchParameters from '@/lib/search/discovery/classes/SearchParameters';

export default function createSearchAction(api) {
  const requests = new WeakMap();

  return function search({
    commit, dispatch, state, rootState,
  }, {
    searchString = '', facetList, currentPage = 1, rowsPerPage, orderBy,
  }) {
    requests.get(state)?.controller.abort();
    const request = { controller: new AbortController() };
    requests.set(state, request);
    commit('setSearchError', null);
    commit('setSearchString', searchString);
    const parameters = Object.assign(new SearchParameters(), state.searchParams, {
      filters: JSON.parse(JSON.stringify(facetList?.selectedFacets || [])),
      select: [...state.searchParams.select],
      orderBy,
      page: currentPage,
      documentsPerPage: rowsPerPage || state.rowsPerPage,
      source: rootState.common.searchLog.source,
      pageName: rootState.common.searchLog.page,
    });
    const isCurrent = () => requests.get(state) === request;

    return new Promise((resolve) => {
      const doSearch = async (index) => {
        if (!isCurrent()) { resolve(); return; }
        parameters.indexId = index.deploymentIndexId;
        dispatch('common/showBusyCursor', parameters.q ? `Searching for ${parameters.q} ...` : 'Loading content...', { root: true });
        try {
          const result = await api.search(parameters, { signal: request.controller.signal });
          if (isCurrent()) {
            commit('setSearchResult', result);
            commit('updateFacetListSort');
            commit('setFacetChipsForSemanticSearch', parameters.isSemanticSearch);
          }
          resolve(result);
        } catch (error) {
          if (isCurrent()) commit('setSearchError', error);
          resolve();
        } finally {
          if (isCurrent()) {
            dispatch('common/resetSearchLog', null, { root: true });
            dispatch('common/hideBusyCursor', null, { root: true });
          }
        }
      };
      dispatch('common/executeWhenDeploymentIndexIsAvailable', doSearch, { root: true });
    });
  };
}
